<template>
  <div class="d-flex align-items-center flex-wrap">
    <b-button
      @click="onClick"
      variant="primary"
      class="text-nowrap mr-0 d-block"
      :class="[
        { 'btn-outline': join },
        { 'btn-outline-info': isPending },
        { 'btn-info': isPending },
        { 'btn-danger': userRejected && !canRetry }
      ]"
      :disabled="(isPending || userLeft || userRejected) && !canRetry"
      size="lg"
    >
      <span
        class="join-campaign text-uppercase text-nowrap"
        v-if="join && !isPending && !canRetry"
      >
        {{ $t('leaveTask') }}
      </span>
      <span
        v-if="!join && !isPending && !userLeft && !userRejected && !canRetry"
        class="join-campaign text-uppercase text-nowrap"
      >
        {{ $t('joinTask') }}
      </span>
      <span v-if="isPending && !canRetry"> {{ $t('isPending') }} </span>
      <span v-if="userLeft && !userRejected && !retry">
        {{ $t('userLeft') }}
      </span>
      <span v-if="userRejected && !canRetry">{{ $t('rejected') }}</span>
      <span v-if="canRetry">{{ $t('retry') }}</span>
    </b-button>
  </div>
</template>

<script>
import { toUTCDate } from '@/utils/date';

export default {
  props: {
    join: {
      type: Boolean,
      required: true
    },
    isPending: {
      type: Boolean,
      default: false
    },
    userLeft: {
      type: Boolean,
      default: false
    },
    userRejected: {
      type: Boolean,
      default: false
    },
    participant: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    canRetry() {
      if (!this.participant || !this.participant.nextJoinAt) {
        return false;
      }
      const nextJoin = toUTCDate(new Date(this.participant.nextJoinAt));
      const now = toUTCDate(new Date());

      return now >= nextJoin;
    }
  },

  methods: {
    onClick() {
      this.$emit(this.join && !this.canRetry ? 'leave' : 'join');
    }
  }
};
</script>

<style>
.error {
  font-size: 0.8rem;
  line-height: 1.2;
}
</style>
